import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["step"];

  toggle() {
    let currentTarget = this.stepTargets.filter((t) => !t.classList.contains('hidden'))[0];
    currentTarget.classList.toggle('hidden');

    let nextStep = currentTarget.dataset.nextStep;
    let el = document.getElementById(nextStep);
    el.classList.toggle('hidden');
  }

  updateNavigation(type, current, to) {
    const nav = document.getElementById('nav-authentication');
    nav.dataset.previousType = type;
    nav.dataset.current = current;
    nav.dataset.previousTo = to;
  }

  stepOne() {
    let stepTwo = document.getElementById('step-2');

    if (stepTwo != undefined) {
      this.toggle();
      this.updateNavigation("element", "step-2", "step-1");
    }
    else {
      this.submit();
    }
  }

  stepTwo() {
    let stepThree = document.getElementById('step-3');

    if (stepThree != undefined) {
      this.toggle();
      this.updateNavigation("element", "step-3", "step-2");
    }
    else {
      this.submit();
    }
  }

  stepThree() {
    let stepFour = document.getElementById('step-4');

    if (stepFour != undefined) {
      this.toggle();
      this.updateNavigation("element", "step-4", "step-3");
    }
    else {
      this.submit();
    }
  }

  stepFour() {
    let stepFive = document.getElementById('step-5');

    if (stepFive != undefined) {
      this.toggle();
      this.updateNavigation("element", "step-5", "step-4");
    }
    else {
      this.submit();
    }
  }

  stepFive() {
    let stepSix = document.getElementById('step-6');

    if (stepSix != undefined) {
      this.toggle();
      this.updateNavigation("element", "step-6", "step-5");
    }
    else {
      this.submit();
    }
  }

  stepSix() {
    let stepSeven = document.getElementById('step-7');

    if (stepSeven != undefined) {
      this.toggle();
      this.updateNavigation("element", "step-7", "step-6");
    }
    else {
      this.submit();
    }
  }

  stepSeven() {
    let stepEight = document.getElementById('step-8');

    if (stepEight != undefined) {
      this.toggle();
      this.updateNavigation("element", "step-8", "step-7");
    }
    else {
      this.submit();
    }
  }

  stepEight() {
    let stepNine = document.getElementById('step-9');

    if (stepNine != undefined) {
      this.toggle();
      this.updateNavigation("element", "step-9", "step-8");
    }
    else {
      this.submit();
    }
  }
}